// const API_URL = "http://localhost:7001";
// const SOCKET_URL = 'http://localhost:6069'

const API_URL = "https://api.vivatronik.pl";
const SOCKET_URL = "https://socket.vivatronik.pl";

const apiKeyGus = "db2d7574f81445aeb71c";
const apiUrlGus = "https://wyszukiwarkaregon.stat.gov.pl/wsBIR/UslugaBIRzewnPubl.svc";
const apiWsdlGus = "https://wyszukiwarkaregon.stat.gov.pl/wsBIR/wsdl/UslugaBIRzewnPubl-ver11-prod.wsdl";

export { API_URL, SOCKET_URL, apiUrlGus, apiKeyGus, apiWsdlGus };
